<template>
  <b-row class="tabs margin-0">
    <b-col
      id="no-print"
      v-if="isDesktopTabs"
      cols="12"
      lg="auto"
      class="padding-0 padding-left-24 mobile-none tablet-none width-324"
    >
      <ul class="desktop-tabs__items">
        <slot name="extra-options"></slot>
        <slot name="tab-items" :items="generateTabs">
          <li
            v-for="{ id, icon, text } in generateTabs"
            :key="`a-${id}`"
            :class="{ 'desktop-tabs__item--active': id === currentTabId }"
            class="desktop-tabs__item"
            @click.stop="handleSelectTab(id)"
          >
            <span class="desktop-tabs__item-icon">
              <mdicon :name="icon" size="24" />
            </span>
            <span class="desktop-tabs__item-text"> {{ text }} </span>
          </li>
        </slot>
      </ul>
    </b-col>
    <b-col
      id="no-print"
      cols="12"
      class="padding-0 flex-between"
      :class="{ 'desktop-none flex-direction-column': isDesktopTabs }"
    >
      <div v-if="isDesktopTabs" class="width-percent-100">
        <slot name="extra-options"></slot>
      </div>
      <ul class="tabs__items">
        <li
          v-for="{ id, text } in generateTabs"
          :key="`b-${id}`"
          :class="{ 'tabs__item--active': id === currentTabId }"
          class="tabs__item"
          @click="handleSelectTab(id)"
        >
          {{ text }}
        </li>
      </ul>
      <slot name="left-area"> </slot>
    </b-col>
    <b-col
      id="section-to-print"
      cols="12"
      :lg="isDesktopTabs ? '' : '12'"
      class="padding-0 overflow-x-hidden overflow-y-auto"
      :class="`${
        isDesktopTabs ? 'desktop-tabs__content' : 'tabs__content'
      } ${tabContentClass}`"
    >
      <slot :name="`tab-${currentTabId}`"></slot>
    </b-col>
  </b-row>
</template>

<script>
import { computed, onMounted, ref, toRefs } from "vue";
import { is } from "ramda";
export default {
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    isDesktopTabs: {
      type: Boolean,
      default: false,
    },
    tabContentClass: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { tabs, isDesktopTabs, tabContentClass } = toRefs(props);

    const generateTabs = computed(() => {
      return tabs.value
        .map((item, index) => {
          const row = is(String, item) ? { text: item } : item;
          return { id: index, icon: null, show: true, ...row };
        })
        .filter(({ show }) => show);
    });

    // select current tab with index
    const currentTabId = ref(0);
    const handleSelectTab = (selectedId = 0) => {
      currentTabId.value = selectedId;
      const currentTab = generateTabs.value.find(({ id }) => id === selectedId);
      emit("getCurrentTab", currentTab);
    };

    // select first tab when mounted the component
    onMounted(() => handleSelectTab());

    // return data to be used in template
    return {
      isDesktopTabs,
      currentTabId,
      generateTabs,
      handleSelectTab,
      tabContentClass,
    };
  },
};
</script>
